
import request from '@/utils/request'
import { Message } from 'element-ui'
import { flowCode } from '../config/index'
export default {
  // 创建流程实例ID
  async createFlow() {
    const params = {
      flow_code: flowCode, // 流程编号
    }
    let instanceId = ''
    try {
      const res = await request.get('/cluepool/pc/form/createInstanceId', params, '')
      if (res.code === 200) {
        instanceId = res.data || ''
      } else {
        Message.error(res.message || '创建流程实例失败')
      }
    } catch (error) {
      console.log('创建流程实例失败', error)
    }
    return instanceId
  },

  // 生成表单id
  async createFormId() {
    let formId = ''
    try {
      const res = await request.post('/cluepool/pc/form/createFormDataId', {}, '')
      if (res.code === 200) {
        formId = res.data || ''
      } else {
        Message.error(res.message || '生成表单id失败')
      }
    } catch (error) {
      console.log('生成表单id失败', error)
    }
    return formId
  },

  // 获取流程
  async getFlow() {
    const params = {
      flowCode // 流程编号
    }
    let data = {}
    try {
      const res = await request.post('/cluepool/pc/form/getFlow', params, '')
      if (res.code === 200) {
        // console.log('获取流程res', res)
        data = res.data
      } else {
        Message.error(res.message || '获取流程失败')
      }
    } catch (error) {
      console.log('获取流程失败', error)
    }
    return data
  },

  // 获取流程实例
  async getFlowInstance(instanceId) {
    const params = {
      flow_instance_id: instanceId // 流程实例ID
    }
    let data = {}
    try {
      const res = await request.get('/cluepool/pc/form/getFlowInstance', params, '')
      if (res.code === 200) {
        data = res.data
      } else {
        Message.error(res.message || '获取流程实例失败')
      }
    } catch (error) {
      console.log('获取流程实例失败', error)
    }
    return data
  },

  // 获取表单
  async getFlowForm(formCode = '') {
    const params = {
      formCode // 表单编号
    }
    let data = {}
    try {
      const res = await request.post('/cluepool/pc/form/getForm', params, '')
      if (res.code === 200) {
        data = {
          ...(res.data || {}),
          field: (res.data.field || []).map(item => ({
            ...item,
            resultFieldName: item.fieldName + '_formCode_' + item.formCode
          }))
        }
      } else {
        Message.error(res.message || '获取表单失败')
      }
    } catch (error) {
      console.log('获取表单失败', error)
    }
    // console.log('获取表单字段', data)
    return data
  },

  // 获取表单数据
  async getFormData({ instanceId, stepCode, stepId, formCode, doctorId, dataType = 'obj', interfaceType = '', formDataId = '' }) {
    const params = {
      instanceId, // 流程实例ID
      stepCode, // 步骤编号
      stepId, // 步骤ID
      formCode,
      ...doctorId && {
        doctorId
      },
      ...formDataId && { // 表单数据ID
        primaryKeyId: formDataId
      }
    }
    let data = {
      formData: {}
    }
    let dataList = []
    try {
      let url = ''
      if (formDataId) {
        url = '/cluepool/pc/form/loadFormDataByPrimary'
      } else {
        // 通过医生ID和表单code获取当前医生下“所有实例”中指定表单的“所有数据”
        // url = '/cluepool/pc/form/getFormDataByDoctorId'

        // 通过医生ID和表单code获取当前医生下“所有流程实例”中指定表单，最后一次提交的表单数据（一条数据/多条数据）
        url = '/cluepool/pc/form/lastFormData'
        if (interfaceType === 'loadFormData') {
          // 通过流程实例和表单code获取当前流程实例下的指定表单的“所有数据”
          url = '/cluepool/pc/form/loadFormData'
        } else if (interfaceType === 'stepId') {
          url = '/cluepool/pc/form/getFormData'
        } else if (interfaceType === 'stepCode') {
          url = '/cluepool/pc/form/getFormData2'
        } else if (interfaceType === 'instanceId') {
          url = '/cluepool/pc/form/getFormData3'
        }
      }
      const res = await request.post(url, params, '')
      if (res.code === 200) {
        if (dataType === 'list') {
          (res.data || []).forEach(el => {
            const fieldData = el.fieldData || []
            const formData = {}
            for(const item of fieldData) {
              formData[item.fieldName + '_formCode_' + item.formCode] = {
                zhName: item.zhName,
                value: item.value,
                inputType: item.inputType
              }
            }
            dataList.push({
              needCreateFormId: instanceId !== el.doctorStageId,
              formCode: params.formCode, 
              formData,
              formName: el.formName,
              createTime: el.createTime,
              updateTime: el.updateTime,
              instanceId: instanceId,
              doctorStageId: el.doctorStageId,
              stepCode: el.stepCode,
              stepId: el.stepId
            })
          })
        } else {
          const newFormData = (res.data || []).sort((a, b) => (b.createTime ? +new Date(b.createTime) : 0) - (a.createTime ? +new Date(a.createTime) : 0))[0] || {}
          const fieldData = newFormData.fieldData || []
          const formData = {}
          for(const item of fieldData) {
            formData[item.fieldName + '_formCode_' + item.formCode] = {
              zhName: item.zhName,
              value: item.value,
              inputType: item.inputType
            }
          }
          data = {
            needCreateFormId: instanceId !== newFormData.doctorStageId,
            formCode: params.formCode, 
            formData,
            formName: newFormData.formName,
            createTime: newFormData.createTime,
            updateTime: newFormData.updateTime,
            instanceId: instanceId,
            doctorStageId: newFormData.doctorStageId,
            stepCode: newFormData.stepCode,
            stepId: newFormData.stepId
          }
        }
      } else {
        Message.error(res.message || '获取表单数据失败')
      }
    } catch (error) {
      console.log('获取表单数据失败', error)
    }
    return dataType === 'list' ? dataList : data
  },

  // 提交表单数据
  async submitFormData({ flowInstanceId, followAction, formData, stepCode, stepId }) {
    const params = {
      flowInstanceId, // 流程实例ID
      followAction, // 跟进动作
      formData: formData.map(item => ({
        ...item,
        operate: item.operate ? item.operate : '' // 操作类型 1.追加 2.新增/修改 3.修改 4.删除 (现阶段只支持4,其他类型都不支持,直接为空)
      })), // 表单数据
      stepCode, // 步骤编号
      stepId // 步骤ID
    }
    let res = {}
    try {
      res = await request.post('/cluepool/pc/form/submit', params, '')
      if (res.code === 200) {
      } else {
        Message.error(res.message || '提交表单数据失败')
      }
    } catch (error) {
      console.log('提交表单数据失败', error)
    }
    return res
  },

  // 从流程中，通过步骤id获取对应的表单id列表
  getCurrentFlowStepFormIdList(flowInfo = {}, stepCode = '') {
    const currentFlowStepInfo = (flowInfo.steps || []).find(item => item.stepCode === stepCode)
    let formCodeList = []
    if (currentFlowStepInfo && currentFlowStepInfo.forms.length > 0) {
      // 步骤中表单编号
      formCodeList = currentFlowStepInfo.forms.map(item => item.formCode)
    }
    return formCodeList
  },

  // 获取多个表单字段相关信息
  async getFormFieldList(formCodeList = []) {
    const showFormInfo = {} // 表单字段全部隐藏，则不展示当前表单(key:formCode,value:true/false)
    const formData = {}
    const showFormFieldKeyInfo = {}
    const fieldList = []
    const originOptionsInfo = {}
    const optionsInfo = {}
    for (let i = 0; i < formCodeList.length; i++) {
      try {
        const formCode = formCodeList[i]
        const data = await this.getFlowForm(formCode)
        if (data && data.field && data.field.length > 0) {
          data.field.forEach(el => {
            // el.isShow = 1
            // el.required = 1
            // 获取表单数据(默认值中带有括号代表是后端的函数)
            const defaultValue = (el.defaultValue || '').includes('()') ? '' : (el.defaultValue || '')
            formData[el.resultFieldName] = defaultValue
            // 要展示的表单字段
            showFormFieldKeyInfo[el.resultFieldName] = { ...el }
            // 字段列表集合
            fieldList.push(el)
            // 展示的字段
            if (el.isShow === 1) {
              // 获取选项信息
              if (el.options && el.options.length > 0) {
                originOptionsInfo[el.resultFieldName] = el.options.sort((a, b) => a.sort - b.sort).map((item, index) => ({
                  ...item,
                  index: index,
                  questionItemLabel: item.label,
                  questionItemValue: item.value
                }))
              }
              // inputType: 1：单选 2：多选 3：文本输入
              // 单选
              if (el.inputType === 1) {
                formData[el.resultFieldName] = (originOptionsInfo[el.resultFieldName] || []) .filter(item => (defaultValue || []).includes(item.questionItemValue))
                optionsInfo[el.resultFieldName] = (originOptionsInfo[el.resultFieldName] || []) .map(item => item.questionItemLabel || '')
              }
              // 多选
              if (el.inputType === 2) {
                formData[el.resultFieldName] = (originOptionsInfo[el.resultFieldName] || []) .filter(item => (defaultValue || []).includes(item.questionItemValue))
                optionsInfo[el.resultFieldName] = (originOptionsInfo[el.resultFieldName] || []) .map(item => item)
              }
            }
          })
          showFormInfo[formCode] = data.field.some(item => item.isShow === 1)
        } else {
          showFormInfo[formCode] = false
        }
      } catch (error) {
        console.log('获取多个表单字段相关信息error', error)
      }
    }
    // console.log({
    //   formData,
    //   showFormInfo,
    //   fieldList,
    //   showFormFieldKeyInfo,
    //   originOptionsInfo,
    //   optionsInfo
    // })
    return {
      formData,
      showFormInfo,
      fieldList,
      showFormFieldKeyInfo,
      originOptionsInfo,
      optionsInfo
    }
  },

  // 获是否扭转到了下一个节点(用于提交表单后，判断是否已经到了流程下一个节点)
  isGoFLowNextStep(taskList = [], stepCode) {
    // 按照步骤编号排序（倒序）
    const newTaskList = taskList.sort((a, b) => b.stepId - a.stepId)
    return (newTaskList[0] || {}).stepCode !== stepCode
  },

  // 获取最新的stepId
  getLatestStepId(taskList = []) {
    // 按照步骤编号排序（倒序）
    const newTaskList = taskList.sort((a, b) => b.stepId - a.stepId)
    return (newTaskList[0] || {}).stepId || ''
  }
}